/**------------------------------------------------------
 * Interfaces
 */
export interface IAdminApiTokenData {
	id					: string;
	userId				: string;
	buyQuantity			: number;
	tokenCount			: number;
	remainingTokenCount	: number;
	expires				: Date;
	userMail			: string;
	checkoutId			: string;
	orderId				: string;
	productId			: string;
	productName			: string;
	marketingConsent	: boolean;
	paymentMethod		: string;
	paymentPrice		: string;
	paymentCurrency		: string;
	status				: string;
}

export interface IGetUserApiTokenPackagesResponse {
	apiTokens : IAdminApiTokenData[];
}

export interface IGetUserApiTokenAdminDataResponse extends IAdminApiTokenData { }

export interface ICreateUserApiTokenPackagesRequest {
	userId		: string;
	userEmail	: string;
	tokenAmount	: number;
	expireTime	: Date;
}

export interface IUpdateUserApiTokenCountRequest {
	tokenId		: string;
	tokenAmount	: number;
}
